import { AxiosResponse } from 'axios'
import { featureFlagsByUserGet } from 'lib/featureFlags'
import { getToken } from 'utils/auth'
import { IError, IReducerAction } from '../interface'
import { IFeatureFlag } from './interface'

const PREFIX = 'feature-flags'
export const FEATURE_FLAGS_BY_USER_GET = `${PREFIX}/byUserGet`
export const FEATURE_FLAGS_BY_USER_GET_FULFILLED = `${FEATURE_FLAGS_BY_USER_GET}/fulfilled`
export const FEATURE_FLAGS_BY_USER_GET_REJECTED = `${FEATURE_FLAGS_BY_USER_GET}/rejected`
export const FEATURE_FLAGS_BY_USER_GET_RESET = `${FEATURE_FLAGS_BY_USER_GET}/reset`

export const featureFlagsByUserGetAction = (entityId: string) => (dispatch: React.Dispatch<IReducerAction>) => {
  dispatch({
    type: FEATURE_FLAGS_BY_USER_GET,
    data: null
  })
  featureFlagsByUserGet({ id: entityId, token: getToken() })
    .then(({ data }: AxiosResponse<IFeatureFlag[]>) =>
      dispatch({
        type: FEATURE_FLAGS_BY_USER_GET_FULFILLED,
        data
      })
    )
    .catch((error: IError) =>
      dispatch({
        type: FEATURE_FLAGS_BY_USER_GET_REJECTED,
        data: error
      })
    )
}

export const featureFlagsByUserResetAction = () => (dispatch: React.Dispatch<IReducerAction>) =>
  dispatch({
    type: FEATURE_FLAGS_BY_USER_GET_RESET,
    data: null
  })
